import posthog from "posthog-js";

export enum AnalyticsEvent {
  //SKU list
  SKU_CREATED = "sku_created",
  SKU_EDITED = "sku_edited",
  SKU_ROW_ANALYTICS_BUTTON_CLICKED = "sku_row_analytics_button_clicked",
  SKU_ROW_PAGE_VIEWS_BUTTON_CLICKED = "sku_row_page_views_button_clicked",
  SKU_ROW_TAGS_BUTTON_CLICKED = "sku_row_tags_button_clicked",
  SKU_CSV_DOWNLOADED = "sku_csv_downloaded",
  SKU_DELETED = "sku_deleted",

  // Asset Pages
  FILE_UPLOADED = "file_uploaded",

  // SKU Page Tabs
  TAB_CHANGED = "tab_changed",

  // SKU Webpage Tab
  LEGITIMATE_CMS_EDITED = "cms_edited",

  // Blockchain Tab
  BLOCKCHAIN_ENABLED = "blockchain_enabled",

  // Organization Page
  ORG_MEMBER_ADDED = "org_member_added",
  AUDIT_LOG_REQUESTED = "audit_log_requested",
  CUSTOM_VERIFICATION_TYPE_CREATED = "custom_verification_created",
  CUSTOM_VERIFICATION_TYPE_SAVED = "custom_verification_saved",
}

export function trackEvent(
  event: AnalyticsEvent,
  properties?: Record<string, string | number | boolean | null>,
) {
  posthog.capture(event, properties ?? {});
}
